module.exports = __webpack_public_path__ + "static/media/map-salon.f02eb4f0.png";